import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { TYPES_DISCOUNT } from '../../../utils/common'
import CategoryService from '../core/service'

export const getLocationThunk = createAsyncThunk(
  'category/GET_LOCATION',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getLocation(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getVietnameseLocationThunk = createAsyncThunk(
  'category/GET_VIETNAMESE_LOCATION',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getVietnameseLocation(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getVsicThunk = createAsyncThunk(
  'category/GET_VSIC',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getVsic(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getIcbThunk = createAsyncThunk(
  'category/GET_ICB',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getIcb(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getTimezoneThunk = createAsyncThunk(
  'category/GET_TIMEZONE',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getTimezone(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getPricingPackagesThunk = createAsyncThunk(
  'category/getPricingPackages',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getPricingPackages(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getPricingPackagesByUserTypeThunk = createAsyncThunk(
  'category/getPricingPackagesByUserType',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getPricingPackagesByUserType(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getExchangeRatesThunk = createAsyncThunk(
  'category/getExchangeRates',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getExchangeRates(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getVAT = createAsyncThunk(
  'category/getVAT',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getVAT(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getDiscountOrder = createAsyncThunk(
  'category/getDiscountOrder',
  async (_, { rejectWithValue }) => {
    const response = await CategoryService.getDiscountOrder({
      DiscountObjectTypes: TYPES_DISCOUNT.Order,
    })
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getCompanyHeaderThunk = createAsyncThunk(
  'category/getCompanyHeader',
  async (data, { rejectWithValue }) => {
    try {
      const res = await CategoryService.getCompanyHeader(data)

      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getUserProfileThunk = createAsyncThunk(
  'category/getUserProfile',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getUserProfile(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getVietnameseProvincesThunk = createAsyncThunk(
  'category/getVietnameseProvinces',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getVietnameseProvinces(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getForeignRegionsThunk = createAsyncThunk(
  'category/getForeignRegions',
  async (data, { rejectWithValue }) => {
    const response = await CategoryService.getForeignRegions(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const putLanguage = createAsyncThunk(
  'category/putLanguage',
  async (params, { rejectWithValue }) => {
    try {
      const res = await CategoryService.putLanguage(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
